/*! StartNoStringValidationRegion These strings specify system values for buttons */
export enum DialogTypes {
  Default = "default",
  ReportError = "report-error",
}
/*! EndNoStringValidationRegion */
